import Form from 'react-bootstrap/Form'
import Icon from '../../Icon/Icon'
import Typography from '../../Typography/Typography'
import InputLayout from '../InputLayout/InputLayout'

import './InputPhone.scss'

const InputPhone = ({
    color = 'blue',
    disabled,
    error,
    errorText,
    label,
    name,
    onBlur,
    onChange,
    placeholder,
    touched,
    value,
    ...props
}) => {
    return (
        <InputLayout
            label={label}
            errorText={errorText}
            error={error}
            color={color}
            touched={touched}
            className={'input-phone'}
        >
            <div
                className={`input-phone--prefix input-phone--${color} d-flex align-items-center gap-2 position-absolute top-50 translate-middle-y px-3 ${
                    disabled && 'opacity-50'
                }`}
            >
                <Icon name={'cz'} />
                <Typography variant={'formText'}>+420</Typography>
            </div>
            <Form.Control
                type={'number'}
                autoComplete={'tel-national'}
                className={'rounded-0 text-formPrimary ps-15 pe-3'}
                placeholder={placeholder}
                name={name}
                isInvalid={error && touched}
                value={value}
                onChange={onChange}
                disabled={disabled}
                onBlur={onBlur}
                {...props}
            />
        </InputLayout>
    )
}

export default InputPhone
